import {
  WebGLRenderTarget,
  LinearFilter,
  RGBFormat,
  Mesh,
  Scene,
  ShaderMaterial,
  Vector2,
} from 'three';

import camera from '@/scripts/stage/camera';
import scene from '@/scripts/stage/globals/scene';
import renderer from '@/scripts/stage/globals/renderer';
import { DPI } from '@/scripts/stage/constants';
import emitter from '@/scripts/stage/globals/emitter';
import Triangle from '@/scripts/stage/globals/triangle';


import vert from './fxaa/vert.glsl';
import frag from './fxaa/frag.glsl';

class PostProcessing {
  constructor() {
    this.target = new WebGLRenderTarget(1, 1, {
      minFilter: LinearFilter,
      magFilter: LinearFilter,
      format: RGBFormat,
      stencilBuffer: false,
      depthBuffer: true,
    });


    this.FXAAMaterial = new ShaderMaterial({

      vertexShader: vert,

      fragmentShader: frag,

      uniforms: {
        tInput: {
          value: this.target,
        },
        resolution: {
          value: new Vector2(1, 1),
        },
      },

      depthTest: false,

      depthWrite: false,
    });

    this.quad = new Mesh(Triangle, this.FXAAMaterial);
    this.quad.frustumCulled = false;
    this.scene = new Scene();
    this.scene.autoUpdate = false;
    this.scene.add(this.quad);
    this.addEvents();
    this.resize(window.innerWidth, window.innerHeight);
  }


  render() {
    renderer.setRenderTarget(this.target);
    renderer.render(scene, camera);
    renderer.setRenderTarget(null);
    renderer.render(this.scene, camera);
  }

  resize(w, h) {
    this.w = Math.floor(w * DPI);
    this.h = Math.floor(h * DPI);
    this.target.setSize(this.w, this.h);
    this.FXAAMaterial.uniforms.resolution.value.set(this.w, this.h);
  }

  addEvents() {
    emitter.on('resize', this.resize.bind(this));
  }
}

export default new PostProcessing();
